import { useStore } from 'effector-react'
import { SuccessIcon, ErrorIcon, CancelIcon } from '~/shared/ui/icons'
import { Modal } from '~/shared/ui/Modal'
import { $notificationModal, notificationModalClose } from './model'

export function NotificationModal() {
  const config = useStore($notificationModal)

  return (
    <Modal
      isShow={Boolean(config)}
      onOk={notificationModalClose}
      ok={config?.buttonTitle}
    >
      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        {config?.variant === 'success' && <SuccessIcon />}
        {config?.variant === 'error' && <ErrorIcon />}
        {config?.variant === 'warning' && <CancelIcon />}
      </div>

      <div style={{ marginBottom: '40px', textAlign: 'center' }}>
        {config && 'title' in config && (
          <div style={{ fontSize: '22px', fontWeight: 700 }}>
            {config.title}
          </div>
        )}
        {config && 'description' in config && (
          <div
            style={{ fontSize: '16px', lineHeight: '24px', marginTop: '8px' }}
          >
            {config.description}
          </div>
        )}

        {config && 'content' in config && <>{config.content}</>}
      </div>
    </Modal>
  )
}
